import { render, staticRenderFns } from "./SimplingDetails.vue?vue&type=template&id=a1c0acb2&scoped=true&"
import script from "./SimplingDetails.vue?vue&type=script&lang=js&"
export * from "./SimplingDetails.vue?vue&type=script&lang=js&"
import style0 from "./SimplingDetails.vue?vue&type=style&index=0&id=a1c0acb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c0acb2",
  null
  
)

export default component.exports